import { ReportProductionContractPDF } from "./Components/PDF/ReportProductionProducerPDF";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";

import { DrawerFilterProductionProducer } from "./Components/Form/DrawerFilterProductionProducer";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportProductionProducer = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionContract } = useContextReportsProduction();

  const hasData = !!listReportProductionContract?.data?.length;
  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterProductionProducer key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de produção por corretores com filtros personalizados"
        title="Relatório de produção por corretor"
      />

      <ReportProductionContractPDF />

      {!hasData && !loadingGravar && <NoEmptyPdfCore />}
    </>
  );
};
